import moduleProjectsApp from './projects-app';
import moduleProjects from './projects';

export default {
  namespaced: true,
  modules: {
    projectsApp: moduleProjectsApp,
    projects: moduleProjects,
  },
};
